@if (isAuthorized$ | async) {
  <button class="btn btn-primary"
    [innerHTML]="'context-menu.actions.subscribe.btn' | translate"
    (click)="$event.preventDefault();openSubscription();">
  </button>
}
